export type ToastType = 'success' | 'error';

export interface ToastItem {
    id: string;
    type: ToastType;
    message: string;
}

type ToastDispatcher = (type: ToastType, message: string) => void;

let dispatchToast: ToastDispatcher | null = null;

export function registerToastDispatcher(dispatcher: ToastDispatcher | null) {
    dispatchToast = dispatcher;
}

function showToast(type: ToastType, message: string) {
    if (!message.trim()) return;
    dispatchToast?.(type, message);
}

export const toast = {
    success(message: string) {
        showToast('success', message);
    },
    error(message: string) {
        showToast('error', message);
    },
};
